import { useQuery } from "@tanstack/react-query";
import { EmployeeFormValues } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/EmployeeEmployment/types/employeeTypes";
import { fetchEmploymentData } from "src/Pages/Company/EmployeeManagement/CompanyEmployees/Edit/EmployeeEmployment/api/api";

const useFetchEmploymentData = (companyId: string, employeeId: string) =>
  useQuery<EmployeeFormValues, Error>({
    queryKey: ["employment-data", companyId, employeeId],
    queryFn: async ({ signal }) =>
      fetchEmploymentData(companyId, employeeId, { signal }),
    enabled: !!companyId && !!employeeId,
  });

export default useFetchEmploymentData;
